// Per-route SEO copy (EN / FI / TR / ES)
export const SEO_META = {
  home: {
    title: {
      en: "Parametric 3D Wood Wall Panels & Architectural Surfaces",
      fi: "Parametriset 3D-puuseinäpaneelit ja arkkitehtoniset pinnat",
      tr: "Parametrik 3D Ahşap Duvar Panelleri ve Mimari Yüzeyler",
      es: "Paneles de pared de madera 3D paramétricos y superficies arquitectónicas",
    },
    description: {
      en: "HRD Architecture designs and mills parametric 3D wood wall panels, acoustic surface systems and CNC wood cladding in Helsinki (Finland) and Istanbul (Türkiye). Meet the MATCH Collection 2026.",
      fi: "HRD Architecture suunnittelee ja jyrsii parametrisia 3D-puuseinäpaneeleita, akustisia pintajärjestelmiä ja CNC-puuverhouksia Helsingissä ja Istanbulissa. Tutustu MATCH-kokoelmaan 2026.",
      tr: "HRD Architecture, Helsinki (Finlandiya) ve İstanbul (Türkiye) arasında parametrik 3D ahşap duvar panelleri, akustik yüzey sistemleri ve CNC ahşap kaplamalar tasarlar ve üretir. MATCH Koleksiyonu 2026 ile tanışın.",
      es: "HRD Architecture diseña y fresa paneles de pared de madera 3D paramétricos, sistemas de superficie acústica y revestimientos de madera CNC en Helsinki (Finlandia) y Estambul (Türkiye). Descubre la Colección MATCH 2026.",
    },
  },
  products: {
    title: {
      en: "MATCH Collection 2026 · Modular Surface Systems",
      fi: "MATCH-kokoelma 2026 · Modulaariset pintajärjestelmät",
      tr: "MATCH Koleksiyonu 2026 · Modüler Yüzey Sistemleri",
      es: "Colección MATCH 2026 · Sistemas de superficie modulares",
    },
    description: {
      en: "Four repeatable CNC routed panel series in 6 mm MDF: KAARI, HAVU, VIRTA and KEHÄ. Download the product PDF for each collection.",
      fi: "Neljä toistettavaa CNC-jyrsittyä paneelisarjaa 6 mm MDF-levyssä: KAARI, HAVU, VIRTA ja KEHÄ. Lataa jokaisen kokoelman tuote-PDF.",
      tr: "6 mm MDF üzerine CNC ile işlenmiş dört tekrarlanabilir panel serisi: KAARI, HAVU, VIRTA ve KEHÄ. Her koleksiyonun ürün PDF'ini indirin.",
      es: "Cuatro series de paneles repetibles fresados por CNC en MDF de 6 mm: KAARI, HAVU, VIRTA y KEHÄ. Descarga el PDF de producto de cada colección.",
    },
  },
  services: {
    title: {
      en: "Services · CNC Milling, Acoustics and Joinery",
      fi: "Palvelut · CNC-jyrsintä, akustiikka ja puusepäntyö",
      tr: "Hizmetler · CNC İşleme, Akustik ve Ahşap İşleri",
      es: "Servicios · Fresado CNC, acústica y carpintería",
    },
    description: {
      en: "Parametric wall panels, acoustic surface systems, CNC wood cladding, bespoke joinery, interior architecture and site supervision from a single studio.",
      fi: "Parametriset seinäpaneelit, akustiset pintajärjestelmät, CNC-puuverhoukset, mittatilauspuusepäntyö, sisustusarkkitehtuuri ja työmaavalvonta yhdestä studiosta.",
      tr: "Parametrik duvar panelleri, akustik yüzey sistemleri, CNC ahşap kaplama, özel ahşap işleri, iç mimarlık ve şantiye kontrolü tek bir stüdyodan.",
      es: "Paneles de pared paramétricos, sistemas de superficie acústica, revestimientos de madera CNC, carpintería a medida, arquitectura de interiores y supervisión de obra desde un solo estudio.",
    },
  },
  portfolio: {
    title: {
      en: "Portfolio · Delivered Interiors and Surfaces",
      fi: "Portfolio · Toteutetut sisätilat ja pinnat",
      tr: "Portföy · Tamamlanmış İç Mekanlar ve Yüzeyler",
      es: "Portafolio · Interiores y superficies entregados",
    },
    description: {
      en: "Selected HRD projects across residential, retail, hospitality, wellness, healthcare, office and F&B interiors in Türkiye and Finland.",
      fi: "Valitut HRD-projektit asuin-, myymälä-, hotelli-, hyvinvointi-, terveydenhuolto-, toimisto- ja ravintolatiloissa Türkiyessä ja Suomessa.",
      tr: "Türkiye ve Finlandiya'da konut, perakende, konaklama, wellness, sağlık, ofis ve yeme-içme iç mekanlarında seçilmiş HRD projeleri.",
      es: "Proyectos seleccionados de HRD en interiores residenciales, retail, hostelería, wellness, salud, oficinas y restauración en Türkiye y Finlandia.",
    },
  },
  about: {
    title: {
      en: "About HRD · Architecture and Manufacturing Since 2009",
      fi: "Tietoa HRD:stä · Arkkitehtuuria ja valmistusta vuodesta 2009",
      tr: "HRD Hakkında · 2009'dan Beri Mimarlık ve Üretim",
      es: "Sobre HRD · Arquitectura y fabricación desde 2009",
    },
    description: {
      en: "HRD has delivered architectural and interior design with in-house CNC manufacturing since 2009, led by founding partners Hüseyin and Reyhan Demirkundak.",
      fi: "HRD on tuottanut arkkitehti- ja sisustussuunnittelua sekä omaa CNC-valmistusta vuodesta 2009, perustajaosakkaiden Hüseyin ja Reyhan Demirkundakin johdolla.",
      tr: "HRD, kurucu ortaklar Hüseyin ve Reyhan Demirkundak liderliğinde 2009'dan bu yana mimari ve iç mekan tasarımını kendi CNC üretimiyle birlikte sunuyor.",
      es: "HRD ofrece diseño arquitectónico y de interiores con fabricación CNC propia desde 2009, dirigida por los socios fundadores Hüseyin y Reyhan Demirkundak.",
    },
  },
  contact: {
    title: {
      en: "Contact · Start a Surface Project",
      fi: "Ota yhteyttä · Aloita pintaprojekti",
      tr: "İletişim · Yüzey Projenize Başlayın",
      es: "Contacto · Inicia un proyecto de superficie",
    },
    description: {
      en: "Send your drawings or wall areas and receive a system proposal, sample box and indicative pricing. Studios in Helsinki, Finland and Istanbul, Türkiye.",
      fi: "Lähetä piirustuksesi tai seinäpinta-alat ja saat järjestelmäehdotuksen, mallilaatikon ja suuntaa antavan hinnan. Studiot Helsingissä ja Istanbulissa.",
      tr: "Çizimlerinizi veya duvar alanlarınızı gönderin; sistem önerisi, numune kutusu ve ön fiyat alın. Stüdyolar Helsinki, Finlandiya ve İstanbul, Türkiye'de.",
      es: "Envía tus planos o las áreas de pared y recibe una propuesta de sistema, caja de muestras y precio indicativo. Estudios en Helsinki (Finlandia) y Estambul (Türkiye).",
    },
  },
};
